// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"e2b1d128","195":"e2b1d128","280":"e2b1d128","479":"e2b1d128","759":"e2b1d128"}[chunkId] + ".chunk.css";
};